import React from 'react';

export const CurrencyContext = React.createContext({});
